import { render, staticRenderFns } from "./CndAcoes.vue?vue&type=template&id=54970b25&scoped=true&"
import script from "./CndAcoes.vue?vue&type=script&lang=js&"
export * from "./CndAcoes.vue?vue&type=script&lang=js&"
import style0 from "./CndAcoes.vue?vue&type=style&index=0&id=54970b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54970b25",
  null
  
)

export default component.exports